import { password } from "marvin-auth-kit";
import { useMutation, UseMutationOptions } from "react-query";
import { APIError } from "src/types";

type PasswordForgotMutationOptions = UseMutationOptions<void, APIError[] | Error, { email: string }, unknown>;
export function usePasswordForgotMutation(options?: PasswordForgotMutationOptions) {
  async function mutationFn(email: string) {
    const response = await password.request(email);
    return response;
  }

  return useMutation((values) => mutationFn(values.email), options);
}
